import { useState, useEffect } from "react";
import { getUser, getUserRoutines, deleteRoutine, deleteRoutineActivity } from "../api";

function MyRoutines(props) {
    const {token, setRoutineId, setMakeRoutine, setEditRoutine, setEditName, setEditGoal, setUser, user, setUserRoutines, userRoutines, setAttachActivity, setRoutineActivityId, setEditRoutineActivity, setEditCount, setEditDuration} = props;
    const gettingUserAndRoutines = async () => {
        try {
            const userResult = await getUser(token);
            setUser(userResult.username);
            const userRoutinesResult = await getUserRoutines(userResult.username);
            setUserRoutines(userRoutinesResult);
        } catch (err) {
            console.error("Failed to fetch user data or user routines", err);
        }     
    };

    useEffect(() => {
        gettingUserAndRoutines();
    }, [token]);

    return (
        <>
            <div id="my-routine-container">
                <button type="button" onClick={((event) => {
                    event.preventDefault();
                    setMakeRoutine(true);
                })} className="form-button">Create New Routine</button>
                <div id="greeting">Hello, {user}</div>
                <div>Your routines:</div>
                {
                    userRoutines[0] ? userRoutines.map((routine) => {
                        return <div key={routine.id} className="routine">
                            <div>{routine.name}</div>
                            <div>{routine.goal}</div>
                            {
                                routine.isPublic ? <div>Public</div> : <div>Private</div>
                            }
                            <div>Activities:
                                {
                                    routine.activities.map((activity) => {
                                        return <div key={activity.id} className='routineActivities'>
                                            <div>Name: {activity.name}</div>
                                            <div>Description: {activity.description}</div>
                                            <div>Duration: {activity.duration}</div>
                                            <div>Count: {activity.count}</div>
                                            <button className="small-form-button small-delete" onClick={(event) => {
                                                event.preventDefault();
                                                deleteRoutineActivity(activity.routineActivityId, token);
                                                gettingUserAndRoutines();
                                            }}>Delete Activity</button>
                                            <button className="small-form-button" onClick={(event) => {
                                                event.preventDefault();
                                                setRoutineActivityId(activity.routineActivityId);
                                                setEditCount(activity.count);
                                                setEditDuration(activity.duration);
                                                setEditRoutineActivity(true);
                                            }}>Edit Activity</button>
                                        </div>
                                    })
                                }
                            </div>
                            <button onClick={(event) => {
                                event.preventDefault();
                                setRoutineId(routine.id);
                                setAttachActivity(true);
                            }} className="small-form-button">Add Activities</button>
                            <button onClick={(event) => {
                                event.preventDefault();
                                setRoutineId(routine.id);
                                setEditRoutine(true);
                                setEditName(routine.name);
                                setEditGoal(routine.goal);
                            }} className="small-form-button">
                                Edit Routine
                            </button>
                            <button onClick={(event) => {
                                event.preventDefault();
                                deleteRoutine(routine.id, token);
                                gettingUserAndRoutines();
                            }} className="small-form-button small-delete">Delete Routine</button>
                        </div>
                    }) : <div>You have no routines!</div>
                }
            </div>
        </>
    )
}

export default MyRoutines;